// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-match-referee-assignment__container,
.league-match-referee-assignment__teams-payment-info {
    padding: 0 var(--space-x3);
}

.league-match-referee-assignment__teams-payment-info.baloa-table {
    margin: var(--space-and-half) 0;
    color: var(--primary-very-dark-color);
}

.league-match-referee-assignment__teams-payment-info {
    margin-top: var(--space-x2);
}

.league-match-referee-assignment__teams-payment-info .baloa-hyperlink-2 {
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space-half);
}

.league-match-referee-assignment__teams-payment-info__values {
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space-half);
}

.league-match-referee-assignment__teams-payment-info__values .baloa-hyperlink-2 {
    padding: var(--space-half) var(--space-half-quarter);
    color: var(--primary-very-dark-color);
    border-bottom: 1px solid var(--new-gray-background-color);
}

.league-match-referee-assignment__teams-payment-info__values__container {
    margin: var(--space-half) var(--space-half-quarter);
    border: 1px solid var(--new-gray-background-color);
    padding: var(--space-half-quarter) var(--space-and-half);
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.league-match-referee-assignment__referee .search_members_staff_edit_content .MuiListItem-container {
    background-color: var(--white-color);
}

.league-match-referee-assignment__referees {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
}

.league-match-referee-assignment__team .baloa-table-column {
    color: var(--primary-dark-color);
    margin-bottom: var(--space-half);
}

.league-match-referee-assignment__referee-container {
    width: 49%;
    margin-bottom: var(--space-x2);
}

.league-match-referee-assignment__referee {
    display: flex;
    align-items: center;
}

.league-match-referee-assignment__referee .MuiAutocomplete-root {
    width: 100%;
}

.league-match-referee-assignment__referee .baloa-username {
    color: var(--primary-very-dark-color);
    white-space: nowrap;
    padding: var(--space) var(--space-half);
    border-top: 1px solid var(--new-gray-background-color);
    border-right: 1px solid var(--new-gray-background-color);
    border-bottom: 1px solid var(--new-gray-background-color);
    border-radius: 0 var(--space-half) var(--space-half) 0;
}

.league-match-referee-assignment__referee .baloa-username.selected {
    padding: calc( var(--space) + var(--space-quarter) ) var(--space-half);
}

.league-match-referee-assignment__referee .search_members_staff_edit_content .input-field-autocomplete div,
.league-match-referee-assignment__referee .search_members_staff_edit_content .MuiListItem-container {
    border-radius: var(--space-half) 0 0 var(--space-half);
}

.league-match-referee-assignment__btns-action {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: var(--space);
    border-top: 1px solid var(--new-gray-background-color);
}

.league-match-referee-assignment__btns-action .secondary-button {
    border: none;
    color: var(--primary-dark-color);
    margin-right: var(--space);
}

.league-match-referee-assignment__btns-action .secondary-button:hover {
    background-color: unset ;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-match-referee-assignment-modal/LeagueMatchRefereeAssignmentModal.styles.css"],"names":[],"mappings":"AAAA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,kDAAkD;IAClD,gCAAgC;AACpC;;AAEA;IACI,oDAAoD;IACpD,qCAAqC;IACrC,yDAAyD;AAC7D;;AAEA;IACI,mDAAmD;IACnD,kDAAkD;IAClD,wDAAwD;IACxD,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,uCAAuC;IACvC,sDAAsD;IACtD,wDAAwD;IACxD,yDAAyD;IACzD,sDAAsD;AAC1D;;AAEA;IACI,sEAAsE;AAC1E;;AAEA;;IAEI,sDAAsD;AAC1D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,sDAAsD;AAC1D;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".league-match-referee-assignment__container,\n.league-match-referee-assignment__teams-payment-info {\n    padding: 0 var(--space-x3);\n}\n\n.league-match-referee-assignment__teams-payment-info.baloa-table {\n    margin: var(--space-and-half) 0;\n    color: var(--primary-very-dark-color);\n}\n\n.league-match-referee-assignment__teams-payment-info {\n    margin-top: var(--space-x2);\n}\n\n.league-match-referee-assignment__teams-payment-info .baloa-hyperlink-2 {\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space-half);\n}\n\n.league-match-referee-assignment__teams-payment-info__values {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space-half);\n}\n\n.league-match-referee-assignment__teams-payment-info__values .baloa-hyperlink-2 {\n    padding: var(--space-half) var(--space-half-quarter);\n    color: var(--primary-very-dark-color);\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.league-match-referee-assignment__teams-payment-info__values__container {\n    margin: var(--space-half) var(--space-half-quarter);\n    border: 1px solid var(--new-gray-background-color);\n    padding: var(--space-half-quarter) var(--space-and-half);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.league-match-referee-assignment__referee .search_members_staff_edit_content .MuiListItem-container {\n    background-color: var(--white-color);\n}\n\n.league-match-referee-assignment__referees {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    width: 100%;\n    justify-content: space-between;\n}\n\n.league-match-referee-assignment__team .baloa-table-column {\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-half);\n}\n\n.league-match-referee-assignment__referee-container {\n    width: 49%;\n    margin-bottom: var(--space-x2);\n}\n\n.league-match-referee-assignment__referee {\n    display: flex;\n    align-items: center;\n}\n\n.league-match-referee-assignment__referee .MuiAutocomplete-root {\n    width: 100%;\n}\n\n.league-match-referee-assignment__referee .baloa-username {\n    color: var(--primary-very-dark-color);\n    white-space: nowrap;\n    padding: var(--space) var(--space-half);\n    border-top: 1px solid var(--new-gray-background-color);\n    border-right: 1px solid var(--new-gray-background-color);\n    border-bottom: 1px solid var(--new-gray-background-color);\n    border-radius: 0 var(--space-half) var(--space-half) 0;\n}\n\n.league-match-referee-assignment__referee .baloa-username.selected {\n    padding: calc( var(--space) + var(--space-quarter) ) var(--space-half);\n}\n\n.league-match-referee-assignment__referee .search_members_staff_edit_content .input-field-autocomplete div,\n.league-match-referee-assignment__referee .search_members_staff_edit_content .MuiListItem-container {\n    border-radius: var(--space-half) 0 0 var(--space-half);\n}\n\n.league-match-referee-assignment__btns-action {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: var(--space);\n    border-top: 1px solid var(--new-gray-background-color);\n}\n\n.league-match-referee-assignment__btns-action .secondary-button {\n    border: none;\n    color: var(--primary-dark-color);\n    margin-right: var(--space);\n}\n\n.league-match-referee-assignment__btns-action .secondary-button:hover {\n    background-color: unset ;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
